import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/agency-acquisitions", label: "Agency Acquisitions", testid: "nav-agency" },
  { to: "/property-portfolios", label: "Property Portfolios", testid: "nav-portfolios" },
  { to: "/our-brands", label: "Our Brands", testid: "nav-brands" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/careers", label: "Careers", testid: "nav-careers" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || open;

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? "bg-navy shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" data-testid="nav-logo-link" aria-label="OTP Group home">
            <Logo variant="light" />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.slice(1).map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `text-[0.8rem] tracking-kicker uppercase transition-colors duration-200 ${
                    isActive ? "text-white" : "text-steel-light hover:text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          {/* Mobile toggle */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle navigation"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-navy border-t border-white/10" data-testid="mobile-menu">
          <nav className="mx-auto max-w-7xl px-6 py-6 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                className={({ isActive }) =>
                  `py-3 text-sm tracking-kicker uppercase border-b border-white/5 ${
                    isActive ? "text-white" : "text-steel-light"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
